import Link from "next/link";

export default function BoardLink({
  boardId,
  projectName,
}: {
  boardId: string;
  projectName: string;
}) {
  return (
    <Link href={`/review-board/${boardId}`} passHref={true}>
      {projectName.slice(0, 75)}
    </Link>
  );
}
